var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDot3Vector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 99,
    viewBox: "0 0 35 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6573 36.7045C16.1243 36.7045 14.8816 35.4618 14.8816 33.9289C14.8816 32.396 16.1243 31.1533 17.6573 31.1533C19.1903 31.1533 20.433 32.396 20.433 33.9289C20.433 35.4618 19.1903 36.7045 17.6573 36.7045Z",
    fill: "url(#paint0_linear_451_266)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6573 21.1279C16.1243 21.1279 14.8816 19.8852 14.8816 18.3523C14.8816 16.8193 16.1243 15.5767 17.6573 15.5767C19.1903 15.5767 20.433 16.8193 20.433 18.3523C20.433 19.8852 19.1903 21.1279 17.6573 21.1279Z",
    fill: "url(#paint1_linear_451_266)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6573 5.55119C16.1243 5.55119 14.8816 4.30852 14.8816 2.7756C14.8816 1.24268 16.1243 0 17.6573 0C19.1903 0 20.433 1.24268 20.433 2.7756C20.433 4.30852 19.1903 5.55119 17.6573 5.55119Z",
    fill: "url(#paint2_linear_451_266)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.03476 52.2812C1.50177 52.2812 0.259036 51.0385 0.259036 49.5056C0.259036 47.9727 1.50177 46.73 3.03476 46.73C4.56775 46.73 5.81049 47.9727 5.81049 49.5056C5.81049 51.0385 4.56775 52.2812 3.03476 52.2812Z",
    fill: "url(#paint3_linear_451_266)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.03476 36.7045C1.50177 36.7045 0.259036 35.4618 0.259036 33.9289C0.259036 32.396 1.50177 31.1533 3.03476 31.1533C4.56775 31.1533 5.81049 32.396 5.81049 33.9289C5.81049 35.4618 4.56775 36.7045 3.03476 36.7045Z",
    fill: "url(#paint4_linear_451_266)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.03476 21.1279C1.50177 21.1279 0.259036 19.8852 0.259036 18.3523C0.259036 16.8193 1.50177 15.5767 3.03476 15.5767C4.56775 15.5767 5.81049 16.8193 5.81049 18.3523C5.81049 19.8852 4.56775 21.1279 3.03476 21.1279Z",
    fill: "url(#paint5_linear_451_266)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2243 52.2812C30.6913 52.2812 29.4485 51.0385 29.4485 49.5056C29.4485 47.9727 30.6913 46.73 32.2243 46.73C33.7573 46.73 35 47.9727 35 49.5056C35 51.0385 33.7573 52.2812 32.2243 52.2812Z",
    fill: "url(#paint6_linear_451_266)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2243 36.7045C30.6913 36.7045 29.4485 35.4618 29.4485 33.9289C29.4485 32.396 30.6913 31.1533 32.2243 31.1533C33.7573 31.1533 35 32.396 35 33.9289C35 35.4618 33.7573 36.7045 32.2243 36.7045Z",
    fill: "url(#paint7_linear_451_266)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2243 21.1279C30.6913 21.1279 29.4485 19.8852 29.4485 18.3523C29.4485 16.8193 30.6913 15.5767 32.2243 15.5767C33.7573 15.5767 35 16.8193 35 18.3523C35 19.8852 33.7573 21.1279 32.2243 21.1279Z",
    fill: "url(#paint8_linear_451_266)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6573 83.4233C16.1243 83.4233 14.8816 82.1806 14.8816 80.6477C14.8816 79.1147 16.1243 77.8721 17.6573 77.8721C19.1903 77.8721 20.433 79.1147 20.433 80.6477C20.433 82.1806 19.1903 83.4233 17.6573 83.4233Z",
    fill: "url(#paint9_linear_451_266)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6573 67.8578C16.1243 67.8578 14.8816 66.6152 14.8816 65.0822C14.8816 63.5493 16.1243 62.3066 17.6573 62.3066C19.1903 62.3066 20.433 63.5493 20.433 65.0822C20.433 66.6152 19.1903 67.8578 17.6573 67.8578Z",
    fill: "url(#paint10_linear_451_266)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6573 52.2812C16.1243 52.2812 14.8816 51.0385 14.8816 49.5056C14.8816 47.9727 16.1243 46.73 17.6573 46.73C19.1903 46.73 20.433 47.9727 20.433 49.5056C20.433 51.0385 19.1903 52.2812 17.6573 52.2812Z",
    fill: "url(#paint11_linear_451_266)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M3.03476 98.9999C1.50177 98.9999 0.259036 97.7572 0.259036 96.2243C0.259036 94.6914 1.50177 93.4487 3.03476 93.4487C4.56775 93.4487 5.81049 94.6914 5.81049 96.2243C5.81049 97.7572 4.56775 98.9999 3.03476 98.9999Z",
    fill: "url(#paint12_linear_451_266)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M3.03476 83.4233C1.50177 83.4233 0.259036 82.1806 0.259036 80.6477C0.259036 79.1147 1.50177 77.8721 3.03476 77.8721C4.56775 77.8721 5.81049 79.1147 5.81049 80.6477C5.81049 82.1806 4.56775 83.4233 3.03476 83.4233Z",
    fill: "url(#paint13_linear_451_266)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M3.03476 67.8578C1.50177 67.8578 0.259036 66.6152 0.259036 65.0822C0.259036 63.5493 1.50177 62.3066 3.03476 62.3066C4.56775 62.3066 5.81049 63.5493 5.81049 65.0822C5.81049 66.6152 4.56775 67.8578 3.03476 67.8578Z",
    fill: "url(#paint14_linear_451_266)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2243 98.9999C30.6913 98.9999 29.4485 97.7572 29.4485 96.2243C29.4485 94.6914 30.6913 93.4487 32.2243 93.4487C33.7573 93.4487 35 94.6914 35 96.2243C35 97.7572 33.7573 98.9999 32.2243 98.9999Z",
    fill: "url(#paint15_linear_451_266)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2243 83.4233C30.6913 83.4233 29.4485 82.1806 29.4485 80.6477C29.4485 79.1147 30.6913 77.8721 32.2243 77.8721C33.7573 77.8721 35 79.1147 35 80.6477C35 82.1806 33.7573 83.4233 32.2243 83.4233Z",
    fill: "url(#paint16_linear_451_266)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2243 67.8578C30.6913 67.8578 29.4485 66.6152 29.4485 65.0822C29.4485 63.5493 30.6913 62.3066 32.2243 62.3066C33.7573 62.3066 35 63.5493 35 65.0822C35 66.6152 33.7573 67.8578 32.2243 67.8578Z",
    fill: "url(#paint17_linear_451_266)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_451_266",
    x1: 20.433,
    y1: 32.171,
    x2: 15.4368,
    y2: 34.7618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_451_266",
    x1: 20.433,
    y1: 16.5944,
    x2: 15.4368,
    y2: 19.1851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_451_266",
    x1: 20.433,
    y1: 1.01772,
    x2: 15.4368,
    y2: 3.60846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_451_266",
    x1: 5.81049,
    y1: 47.7477,
    x2: 0.814279,
    y2: 50.3384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_451_266",
    x1: 5.81049,
    y1: 32.171,
    x2: 0.814279,
    y2: 34.7618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_451_266",
    x1: 5.81049,
    y1: 16.5944,
    x2: 0.814279,
    y2: 19.1851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_451_266",
    x1: 35,
    y1: 47.7477,
    x2: 30.0038,
    y2: 50.3384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_451_266",
    x1: 35,
    y1: 32.171,
    x2: 30.0038,
    y2: 34.7618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_451_266",
    x1: 35,
    y1: 16.5944,
    x2: 30.0038,
    y2: 19.1851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_451_266",
    x1: 20.433,
    y1: 78.8898,
    x2: 15.4368,
    y2: 81.4805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_451_266",
    x1: 20.433,
    y1: 63.3244,
    x2: 15.4368,
    y2: 65.9151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_451_266",
    x1: 20.433,
    y1: 47.7477,
    x2: 15.4368,
    y2: 50.3384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_451_266",
    x1: 5.81049,
    y1: 94.4664,
    x2: 0.814279,
    y2: 97.0572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_451_266",
    x1: 5.81049,
    y1: 78.8898,
    x2: 0.814279,
    y2: 81.4805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_451_266",
    x1: 5.81049,
    y1: 63.3244,
    x2: 0.814279,
    y2: 65.9151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_451_266",
    x1: 35,
    y1: 94.4664,
    x2: 30.0038,
    y2: 97.0572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_451_266",
    x1: 35,
    y1: 78.8898,
    x2: 30.0038,
    y2: 81.4805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_451_266",
    x1: 35,
    y1: 63.3244,
    x2: 30.0038,
    y2: 65.9151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#7C25D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3231FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDot3Vector);
export default __webpack_public_path__ + "static/media/dot3-vector.10f8395d2e7ebd43a700ad7cbdab6af4.svg";
export { ForwardRef as ReactComponent };